import { NavLink, Outlet } from "react-router";
import { useSession } from "../../session";
import { ErrorNote } from "../../ui/States";

const TABS = [
  { to: "/admin/videos", label: "영상" },
  { to: "/admin/tags", label: "태그 정책" },
  { to: "/admin/users", label: "사용자" },
  { to: "/admin/keys", label: "접근 키" },
  { to: "/admin/ops", label: "운영" },
] as const;

/** The administrator's screens. The role comes from the server's account; the API checks it again on every call. */
export function AdminLayout() {
  const { state } = useSession();
  if (state.user?.role !== "admin") {
    return (
      <div className="page">
        <ErrorNote message="관리자만 볼 수 있는 화면입니다. 관리자 계정으로 로그인하세요." />
      </div>
    );
  }
  return (
    <div className="page">
      <div className="page-head">
        <h1>관리</h1>
      </div>
      <nav className="tabs" aria-label="관리 메뉴">
        {TABS.map((t) => (
          <NavLink key={t.to} to={t.to}>
            {t.label}
          </NavLink>
        ))}
      </nav>
      <Outlet />
    </div>
  );
}
